
























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiAddFunds, apiSearchFundsList, apiUpdateFunds } from '@/api/funds'
import MonthlyDisbursement from '@/components/echarts/MonthlyDisbursement.vue'
import MonthlyIncomeDisbursement from '@/components/echarts/MonthlyIncomeDisbursement.vue'
import moment from 'moment'
import {
  filterCategoryArray,
  filterTypeArray,
  fundCategoryOptions1,
  fundCategoryOptions2,
  fundsOptions,
  fundStatusOptions,
  fundTypeOptions
} from '@/constant/toolConstant'
import { IRetFunds } from '@/types/funds/types'
import Nav from '@/components/navbar/index.vue'
import { startDateTimeStr, thisStartMonthDay } from '@/utils/time'

@Component({
  name: 'Funds',
  components: {
    MonthlyDisbursement,
    MonthlyIncomeDisbursement,
    Nav
  }
})
export default class extends Vue {
  private fundLoading = false
  private fundsFormVisible = false
  private fundIsAdd = true
  private fundCategoryOptions = fundCategoryOptions1
  private fundTypeOptions = fundTypeOptions
  private fundStatusOptions = fundStatusOptions
  private fundTitle = ''
  private fundsForm: any = {
    id: 0,
    amount: 0,
    memo: '',
    createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    updateTime: '',
    category: 1,
    type: 1,
    status: 1
  }

  private listLoading = false
  private isShowFundsList = false
  private oldFund: IRetFunds | undefined
  private fundsList: IRetFunds[] = []
  private createTimeDisable = true
  private changeCreateTimeVal = '编辑'
  private dateTimeRange: string[] | null = []
  private filterCategoryArray = filterCategoryArray
  private filterTypeArray = filterTypeArray

  private options = fundsOptions
  private optionValue = 1

  private needUpdateChart = true

  private oldSelectedMonth = moment().format('YYYY-MM')
  private selectedMonth = moment().format('YYYY-MM')

  mounted () {
    localStorage.setItem('selectedMonth', this.selectedMonth)
    this.needUpdateChart = false

    this.dateTimeRange = [
      thisStartMonthDay(),
      startDateTimeStr(moment().add(1, 'days'))
    ]
  }

  private changeMonth () {
    if (this.selectedMonth == null || this.selectedMonth === this.oldSelectedMonth) {
      return
    }

    this.needUpdateChart = true
    localStorage.setItem('selectedMonth', this.selectedMonth)
    const calNeedUpdateChart = this.calNeedUpdateChart

    // 让v-if生效(hacker)
    setTimeout(function () {
      calNeedUpdateChart()
    }, 100)
  }

  private calNeedUpdateChart () {
    this.oldSelectedMonth = this.selectedMonth
    this.needUpdateChart = false
  }

  private updateChart () {
    this.needUpdateChart = true
    const calNeedUpdateChart = this.calNeedUpdateChart

    // 让v-if生效(hacker)
    setTimeout(function () {
      calNeedUpdateChart()
    }, 100)
  }

  private async searchFunds () {
    if (this.dateTimeRange == null ||
      this.dateTimeRange.length < 2) {
      this.$message.error('请选择时间范围')
      return
    }

    this.listLoading = true
    this.isShowFundsList = true
    const startTime = moment(this.dateTimeRange[0], 'YYYY-MM-DD HH:mm:ss').unix() * 1000
    const endTime = moment(this.dateTimeRange[1], 'YYYY-MM-DD HH:mm:ss').unix() * 1000
    const param = {
      startTime: startTime,
      endTime: endTime
    }
    this.fundsList = []
    const result = await apiSearchFundsList(param)
    if (result.status) {
      const dataList: IRetFunds[] = result.data
      for (const data of dataList) {
        this.fundsList.push(data)
      }
    }
    this.listLoading = false
  }

  private async addFunds () {
    if (this.fundsForm.amount <= 0) {
      this.$message.error('金额要大于0')
      return
    }

    if (this.fundsForm.memo === '') {
      this.$message.error('请填写备注')
      return
    }

    this.fundLoading = true
    const param = {
      amount: this.fundsForm.amount,
      memo: this.fundsForm.memo,
      createTime: !this.createTimeDisable ? moment(this.fundsForm.createTime, 'YYYY-MM-DD HH:mm:ss').unix() * 1000 : undefined,
      category: this.fundsForm.category,
      type: this.fundsForm.type
    }
    const result = await apiAddFunds(param)
    if (result.status) {
      this.$message.success('添加成功')
      this.fundsList.push(result.data)
      if (!this.isShowFundsList) {
        this.updateChart()
      }
    }
    this.fundsFormVisible = false
    this.fundLoading = false
  }

  private async updateFunds () {
    this.fundLoading = true
    const createTime = moment(this.fundsForm.createTime, 'YYYY-MM-DD HH:mm:ss').unix() * 1000
    const memo = this.oldFund?.memo !== this.fundsForm.memo ? this.fundsForm.memo : undefined
    const param = {
      id: this.fundsForm.id,
      amount: this.fundsForm.amount,
      memo: memo,
      category: this.fundsForm.category,
      createTime: this.oldFund?.createTime !== createTime ? createTime : undefined,
      type: this.fundsForm.type,
      status: this.fundsForm.status
    }
    const result = await apiUpdateFunds(param)
    if (result.status) {
      this.$message.success('更新成功')
      if (this.oldFund !== undefined) {
        const idx = this.fundsList.indexOf(this.oldFund)
        this.fundsList.splice(idx, 1)
        if (result.data.status === 1) {
          this.fundsList.push(result.data)
        }
      }

      if (!this.isShowFundsList) {
        this.updateChart()
      }
    }
    this.fundsFormVisible = false
    this.fundLoading = false
  }

  private addFundButton () {
    this.fundTitle = '添加资金流水'
    this.fundIsAdd = true
    this.createTimeDisable = true
    this.changeCreateTimeVal = '编辑'
    this.fundsForm.createTime = moment().format('YYYY-MM-DD HH:mm:ss')
    this.fundsFormVisible = true
  }

  private updateFundButton (fund: IRetFunds) {
    this.oldFund = fund

    this.fundsForm.id = fund.id
    this.fundsForm.amount = fund.amount
    this.fundsForm.memo = fund.memo
    this.fundsForm.createTime = this.descTime(fund.createTime)
    this.fundsForm.updateTime = this.descTime(fund.updateTime)
    this.fundsForm.category = fund.category
    this.fundsForm.type = fund.type
    this.fundsForm.status = fund.status

    this.fundCategoryOptions = this.fundsForm.type === 1 ? fundCategoryOptions1 : fundCategoryOptions2

    this.fundTitle = '更新资金流水'
    this.fundIsAdd = false
    this.fundsFormVisible = true
  }

  private changeType () {
    if (this.fundsForm.type === 1) {
      this.fundCategoryOptions = fundCategoryOptions1
    } else if (this.fundsForm.type === 2) {
      this.fundCategoryOptions = fundCategoryOptions2
    }

    this.fundsForm.category = ''
  }

  private submitFund () {
    if (this.fundIsAdd) {
      this.addFunds()
    } else {
      this.updateFunds()
    }
  }

  private descTime (createTime: number) {
    return moment(createTime).format('YYYY-MM-DD HH:mm:ss')
  }

  private descCategory (c: number) {
    let categories = fundCategoryOptions1
    if (c > 100) {
      categories = fundCategoryOptions2
    }

    let l = ''
    for (const d of categories) {
      if (d.value === c) {
        l = d.label
        break
      }
    }
    return l
  }

  private descType (t: number) {
    let l = ''
    for (const d of fundTypeOptions) {
      if (d.value === t) {
        l = d.label
        break
      }
    }
    return l
  }

  private changeCreateTime () {
    this.createTimeDisable = !this.createTimeDisable
    if (this.createTimeDisable) {
      this.changeCreateTimeVal = '编辑'
    } else {
      this.changeCreateTimeVal = '取消'
    }
  }

  private filterHandler (value: number, row: any, column: any) {
    const property = column['property']
    return row[property] === value
  }
}
